module.exports = __webpack_public_path__ + "img/batch-nodata.b797b7b2.png";